import { PaymentApiClient } from '@fourthwall/services/dist/PaymentApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useCompleteUserPaymentMethodSetupMutation = createMutationHook(
  PaymentApiClient.completeUserPaymentMethodSetup,
  {
    mutationKey: ['completeUserPaymentMethodSetup'],
  },
)
